module.exports = __webpack_public_path__ + "static/media/ml2022-edit.78020301.jpg";